import Loadable from '@townsquare/loadable';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { notificationsRoute } from '@townsquare/routes/notifications';

const FullPageNotifications = Loadable({
	loader: () => import(/* webpackChunkName: "notifications-view" */ './FullPageNotifications'),
	loading: () => null,
});

notificationsRoute.component = FullPageNotifications;
export const notificationsRouterRoute: GlobalHomePageRoute = notificationsRoute;
